<template>
  <!-- <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">

  </editor-menu-bar> -->
  <div>
    <q-toolbar class="tiptap-menubar q-mb-sm">
      <q-scroll-area
        :thumb-style="{
          background: '#162c479c',
          opacity: 1,
          width: '8px',
          height: '8px',
          borderRadius: '20px',
        }"
        horizontal
        style="height: 50px; width: 100%"
      >
        <div class="row justify-center">
          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('bold') }"
            @click="editor.chain().focus().toggleBold().run()"
          >
            <q-icon name="mdi-format-bold" />
            <q-tooltip> Bold </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('italic') }"
            @click="editor.chain().focus().toggleItalic().run()"
          >
            <q-icon name="mdi-format-italic" />
            <q-tooltip> Italic </q-tooltip>
          </q-btn>

          <!-- <q-btn
            :class="{ 'is-active': isActive.strike() }"
            @click="commands.strike"
          >
            <q-icon name="mdi-format-strike" />
          </q-btn> -->

          <!-- <q-btn
            :class="{ 'is-active': isActive.underline() }"
            @click="commands.underline"
          >
            <q-icon name="mdi-format-underline" />
          </q-btn>

          <q-btn
            :class="{ 'is-active': isActive.code() }"
            @click="commands.code"
          >
            <svgicon name="code" />
          </q-btn> -->

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('paragraph') }"
            @click="editor.chain().focus().setParagraph().run()"
          >
            <q-icon name="mdi-format-paragraph" />
            <q-tooltip> Paragraph </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
            @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
          >
            H1
            <q-tooltip> Heading 1 </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
            @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
          >
            H2
            <q-tooltip> Heading 2 </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
            @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
          >
            H3
            <q-tooltip> Heading 3 </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('bullet_list') }"
            @click="editor.chain().focus().toggleBulletList().run()"
          >
            <q-icon name="mdi-format-list-bulleted" />
            <q-tooltip> Bullet List </q-tooltip>
          </q-btn>

          <q-btn
            class="q-mx-xs"
            :class="{ 'is-active': editor.isActive('ordered_list') }"
            @click="editor.chain().focus().toggleOrderedList().run()"
          >
            <q-icon name="mdi-format-list-numbered" />
            <q-tooltip> Number List </q-tooltip>
          </q-btn>

          <!-- <q-btn
            :class="{ 'is-active': isActive.blockquote() }"
            @click="commands.blockquote"
          >
            <svgicon name="quote" />
          </q-btn>

          <q-btn
            :class="{ 'is-active': isActive.code_block() }"
            @click="commands.code_block"
          >
            <svgicon name="code" />
          </q-btn>

          <q-btn @click="commands.horizontal_rule">
            <svgicon name="hr" />
          </q-btn> -->
          <q-btn
            class="q-mx-xs"
            @click="setLink"
            :class="{ 'is-active': editor.isActive('link') }"
          >
            <q-icon name="mdi-link" />
            <q-tooltip> Highlight and add URL Link </q-tooltip>
          </q-btn>
          <q-btn
            class="q-mx-xs"
            :disabled="!editor.isActive('link')"
            @click="editor.chain().focus().unsetLink().run()"
          >
            <q-icon name="mdi-link-off" />
            <q-tooltip> Highlight and remove URL Link </q-tooltip>
          </q-btn>
          <q-btn class="q-mx-xs" @click="editor.chain().focus().undo().run()">
            <q-icon name="mdi-undo" />
            <q-tooltip> Undo </q-tooltip>
          </q-btn>

          <q-btn class="q-mx-xs" @click="editor.chain().focus().redo().run()">
            <q-icon name="mdi-redo" />
            <q-tooltip> Redo </q-tooltip>
          </q-btn>
        </div>
      </q-scroll-area>
    </q-toolbar>
    <q-dialog v-model="urlDialog">
      <q-card class="card">
        <q-card-section class="bg-accent text-white">
          <div class="row justify-between items-center">
            <span class="text-bold"> Add Link </span>
            <div>
              <q-btn @click="confirmLink" color="green"> Confirm </q-btn>
              <q-btn icon="mdi-close" @click="urlDialog = false" flat round>
              </q-btn>
            </div>
          </div>
        </q-card-section>
        <q-card-section>
          <q-input v-model="url" label="URL Link"></q-input>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
  // import { EditorMenuBar } from "tiptap";
  export default {
    props: ["editor"],
    name: "BasicToolbar",
    mixins: [],
    components: {
      // EditorMenuBar,
    },
    data: () => ({
      url: "",
      urlDialog: false,
    }),
    methods: {
      test(isActive) {
        console.log(isActive.bold());
      },
      confirmLink() {
        // cancelled
        if (this.url === null) {
          return;
        }

        // empty
        if (this.url === "") {
          this.editor.chain().focus().extendMarkRange("link").unsetLink().run();
          return;
        }

        //check if link contains https
        if (!this.url.includes("https://")) {
          this.url = "https://" + this.url;
        }

        // update link
        this.editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .setLink({ href: this.url })
          .run();

        this.urlDialog = false;
      },
      setLink() {
        // const previousUrl = this.editor.getAttributes("link").href;
        // const url = window.prompt("URL", previousUrl);
        this.url = this.editor.getAttributes("link").href;
        this.urlDialog = true;
      },
    },
  };
</script>

<style lang="scss">
  .tiptap-menubar {
    .is-active {
      background: rgba(0, 0, 0, 0.1);
    }
  }
  .card {
    width: 500px;
  }
</style>
